import { render, staticRenderFns } from "./NewRole.vue?vue&type=template&id=703efa35&scoped=true&"
import script from "./NewRole.vue?vue&type=script&lang=js&"
export * from "./NewRole.vue?vue&type=script&lang=js&"
import style0 from "./NewRole.vue?vue&type=style&index=0&id=703efa35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703efa35",
  null
  
)

export default component.exports